// --- START OF FILE src/components/Topbar.jsx ---

import React from 'react';
import { useTranslation } from 'react-i18next'; // MODIFICACIÓN: Importar useTranslation
import '../styles/Topbar.css'; 

// Icono de Logout
const LogoutIcon = () => (
  <svg
    className="topbar-action-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
  >
    <path d="M288 256C288 273.7 273.7 288 256 288C238.3 288 224 273.7 224 256V32C224 14.33 238.3 0 256 0C273.7 0 288 14.33 288 32V256zM80 256C80 353.2 158.8 432 256 432C353.2 432 432 353.2 432 256C432 201.6 407.3 152.9 368.5 120.6C354.9 109.3 353 89.13 364.3 75.54C375.6 61.95 395.8 60.1 409.4 71.4C462.2 115.4 496 181.8 496 255.1C496 388.5 388.5 496 256 496C123.5 496 16 388.5 16 255.1C16 181.8 49.75 115.4 102.6 71.4C116.2 60.1 136.4 61.95 147.7 75.54C158.1 89.13 157.1 109.3 143.5 120.6C104.7 152.9 80 201.6 80 256z"></path>
  </svg>
);

// Icono de Hamburguesa
const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>
);

function Topbar({ user, onLogout, onToggleSidebar }) {
  const { t } = useTranslation(); // MODIFICACIÓN: Hook de traducción

  return (
    <header className="topbar-container">
      <div className="topbar-left-section">
        {onToggleSidebar && ( 
          <button 
            className="hamburger-button" 
            onClick={onToggleSidebar} 
            aria-label={t('topbarHamburgerMenuAriaLabel')} // MODIFICACIÓN
            aria-expanded={/* idealmente, este valor vendría de una prop como isSidebarOpen */ false} 
          >
            <HamburgerIcon />
          </button>
        )}
        {user?.email && (
          <span className="topbar-welcome-message">
            {/* MODIFICACIÓN: Usar t() con interpolación */}
            {t('topbarWelcomeMessage', { email: user.email })}
          </span>
        )}
      </div>
      
      <div className="topbar-user-section">
        <button className="topbar-logout-button" onClick={onLogout}>
          <LogoutIcon />
          <span className="topbar-logout-text">{t('topbarLogoutButton')}</span> {/* MODIFICACIÓN */}
        </button>
      </div>
    </header>
  );
}

export default Topbar;
// --- END OF FILE src/components/Topbar.jsx ---